import Axios from "axios"
import { ApiResponse, handleApiErrors } from ".."
import * as UserModels from "./models"

const baseUrl = () => {
    return `${process.env.REACT_APP_MOBILBASE_API}/api/v1/users`
}

export async function getUsers(): Promise<ApiResponse<UserModels.UsersData>> {
    return Axios.get<UserModels.UsersData>(`${baseUrl()}`)
        .then(res => { return {data: res.data, errorStatus: undefined, errorMessage: undefined} })
        .catch((e) => handleApiErrors<UserModels.UsersData>(e))
}

// Store user. If the userId is 0, this is considered a new user. Otherwise, a user with the ID userId will be updated
export async function storeUser(userId: number, params: UserModels.StoreParams): Promise<ApiResponse<UserModels.UsersData>> {
    if (userId === 0) {
        return Axios.post<UserModels.UsersData>(`${baseUrl()}`, { ...params.body })
            .then(res => { return {data: res.data, errorStatus: undefined, errorMessage: undefined}; })
            .catch((e) => handleApiErrors<UserModels.UsersData>(e))
    } else {
        return Axios.post<UserModels.UsersData>(`${baseUrl()}/${userId}`, { ...params.body })
            .then(res => { return {data: res.data, errorStatus: undefined, errorMessage: undefined} })
            .catch((e) => handleApiErrors<UserModels.UsersData>(e))
    }
}

// This creates a comma separated list of user names from the names list. Needed for the locations management table
const setUserNames = (locations: UserModels.UserLocations): UserModels.UserLocations => {
    locations.result.forEach(element => {
        element.userNames = element.userNamesList.sort((a, b) => {return a.localeCompare(b)}).join(", ")
    })
    return locations
}

export async function getUserLocations(): Promise<ApiResponse<UserModels.UserLocations>> {
    return Axios.get<UserModels.UserLocations>(`${baseUrl()}/locations`)
        .then(res => {return {data: setUserNames(res.data), errorStatus: undefined, errorMessage: undefined}})
        .catch((e) => handleApiErrors<UserModels.UserLocations>(e))
}

export async function storeUserLocations(params: UserModels.StoreUserLocationParams): Promise<ApiResponse<UserModels.UserLocations>> {
    return Axios.post<UserModels.UserLocations>(`${baseUrl()}/locations`, {...params})
        .then(res => {return {data: setUserNames(res.data), errorStatus: undefined, errorMessage: undefined}})
        .catch((e) => handleApiErrors<UserModels.UserLocations>(e))
}
